import * as _ from "lodash";

function addDurationStringLength(value) {
  if (String(value).length === 1) {
    return `0${value}`;
  }
  return value;
}

export function getDurationString(seconds) {
  let duration = Math.round(seconds);
  let durationString;
  if (duration) {
    const hours = Math.floor(duration / 3600);
    duration = duration - hours * 3600;
    const minutes = Math.floor(duration / 60);
    const seconds = duration - minutes * 60;
    durationString = `${minutes}:${addDurationStringLength(seconds)}`;
    if (hours) {
      durationString = `${hours}:${addDurationStringLength(minutes)}:${addDurationStringLength(seconds)}`;
    }
    return durationString;

  }
  return null;
}

export function getAudioStickerDurationString(sticker) {
  let seconds = _.get(sticker, 'audio.duration');
  if (seconds) {
    return getDurationString(seconds);
  }
  return null
}
